export default __webpack_public_path__ + "static/media/icon_guide_notice.a3f84224.svg";